import React from 'react';

interface LogoProps {
  height?: number;
  className?: string;
}

export const AmplifyLogo: React.FC<LogoProps> = ({
  height = 32,
  className,
}) => {
  return (
    <img
      src="/ask-serra-logo.png"
      alt="Ask Serra"
      height={height}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};
